export const capitalizeRegex = /^[A-Z][A-ZÎÏÇÊÈÉÀÂa-zàâäéèêîï -]+$/;
export const prenomRegex = /^[A-ZÀ-Ö][A-Za-zàâäéèêîï -]+$/;
export const onlyCapitalAndSpace = /^[A-ZÉÈÊÀÇ ]+$/;
export const noSpecialCharsRegex = /^[0-9a-zA-ZÉÈÊÀÂÇÎÏ,'éèàêâîïç./\\ -]+$/;
export const mailRegex = /^[\w.-]+@[\w.-]+\.\w+$/;

export const telRegex = /^[0-9]{10}$/;
export const mobileRegex = /^[0-9]{10}$/;
export const cityRegex = new RegExp(
  `^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$`
);
export const onlyStringNumber = /[0-9]+$/;
export const dateFormat = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
export const zipCode = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/;
export const zipCodeWithoutCorsicaDoms = /^(?!20|97|98|99)\d{5}$/;
export const nameRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿ '-]+$/;
